export const MUSIC_LIBRARY_SLICE_TYPE = 'homemusiclibrary';
